import '../App.css';
import React from 'react';
// import Table from 'react-bootstrap/Table';
import {  Alert } from 'react-bootstrap';
import { saveAs } from "file-saver";
// import { dingConverterLing } from '../Api';
import Moment from 'moment-timezone';
import { connect } from 'react-redux';
import { language } from '../language';
import Loading3 from '../Images/loading-3.gif';
import SideBar from '../Component/SideBar';
import * as XLSX from "xlsx";
var timer

class DadingConvertCSV extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: this.props.username,
      token: this.props.token,
      TodayDate: Moment(new Date()).format('DD/MM/YYYY (ddd)'),
      FileName: '',
      FileResultWord: '',
      FinalResult: [],
      hightlight: false,
      disabled: false,
      showNotification: false,
      notificationMessage: '',
      notificationType: 'success',
      userID: this.props.userID,
      loading: false,
      ShowReceipt: false,
      ReceiptDisplay: '',
      AfterConvert: [],
      getKey1: ["B", "S", "SA", "CA", "CF", "SF"],
      getKey2: ["SA", "SB", "SC", "SF", "SD", "SE"],
      Key1Options: ['B', 'S', 'CA', 'CF', 'SA', 'SB', 'SC', 'SD', "SE", "SF"],
      MultiplyDivide: 'M',
      JinNan: false,
      DisplayTotalAmount: '',
      background: '#3C96F4',
      exceldata: '',
    }
    this.UploadFiletxt = this.UploadFiletxt.bind(this);
    // this.ConfirmSaveBet = this.ConfirmSaveBet.bind(this);
    this.processExcel = this.processExcel.bind(this);
    this.CleanData = this.CleanData.bind(this);
    this.fileInputRef = React.createRef();
    this.openFileDialog = this.openFileDialog.bind(this);
    this.onDragOver = this.onDragOver.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  async componentDidMount(){
    const UserAuthorities = JSON.parse(this.props.UserAuthority)
    if ((UserAuthorities && UserAuthorities.Bet) === 0) {
      window.location.href='/Home'; 
    }
  }

  async UploadFiletxt(event) {
    if (event !== undefined) {
      const files = event.target.files;
      event.preventDefault()
      const reader = new FileReader()
      reader.onload = async (e) => {
        const text = (e.target.result)
        this.setState({ FileResultWord: text })
      };
      if (event.target.files) {
        reader.readAsText(event.target.files[0])
        this.setState({ FileName: files[0].name })
      } 
    }
  }

  // async ConfirmSaveBet() {
  //   this.setState({loading: true});
  //   const Key1 = this.state.getKey1
  //   const Key2 = this.state.getKey2
  //   const MultiplyDivide = this.state.MultiplyDivide
  //   const JinNan = this.state.JinNan
  //   let originalText = this.state.FileResultWord;
  //   const Array = this.state.FileResultWord.split('\n')
  //   let Arraynew = []

  //   for(var i=0; i < Array.length; i++) {
  //     const RemoveR = Array[i].replace("\r", "").replace("\r", "")
  //     Arraynew.push(RemoveR)
  //   }
  //   originalText = Arraynew.join('\n')

  //   this.setState({ disabled: true}, async()=>{
  //     if((originalText).length === 0){
  //       this.setState({ notificationType: 'error', loading: false }, ()=>{
  //         this.openNotification('Cannotemptytext')
  //       })
  //     } else {
  //       this.setState({ AfterConvert: [] })
  //       const dadingConverter = await dingConverterLing(this.props.username, Key1, Key2, MultiplyDivide, JinNan, originalText, this.props.token)
  //       if (dadingConverter.error === 'Error Format') {
  //         this.setState({ notificationType: 'error', loading: false }, ()=>{
  //           this.openNotification('FormatError')
  //         })
  //       } else {
  //         if(dadingConverter) {
  //           this.openNotification('Success')
  //           this.setState({ AfterConvert: dadingConverter.lastDadingObj, DisplayTotalAmount: dadingConverter.totalAmount, loading: false, MultiplyDivide: 'M', JinNan: false }, ()=> {
  //             this.exportDading();
  //           })
  //         } 
  //       }
  //     }
  //   })
  // }

  async processExcel() {
    const data = this.state.exceldata;
    const column = data[0] ? Object.keys(data[0]) : [];
    const columnIndexForM = [0, 2, 3, 4]
    const columnIndexForK = [7, 9, 10, 11]
    const columnIndexForT = [14, 16, 17, 18]
    const columnIndexForS = [21, 23, 24, 25]
    let i = '3'
    let AfterConvert = ['D#\n']
    if (data[i] && data[i][column[columnIndexForM[0]]]) {
      AfterConvert.push('1\n')
    }
    while (data[i] && data[i][column[columnIndexForM[0]]]) {
      const bettingstring = `${data[i][column[columnIndexForM[0]]]}#${data[i][column[columnIndexForM[1]]] === '0.00' ? '0' : Number(data[i][column[columnIndexForM[1]]])}#${data[i][column[columnIndexForM[2]]] === '0.00' ? '0' : Number(data[i][column[columnIndexForM[2]]])}${data[i][column[columnIndexForM[3]]] === '0.00' ? '' : `#${Number(data[i][column[columnIndexForM[3]]])}`}\n`
      AfterConvert.push(bettingstring)
      i = (Number(i) + 1).toString()
    }
    i = '3'
    if (data[i] && data[i][column[columnIndexForK[0]]]) {
      AfterConvert.push('2\n')
    }
    while (data[i] && data[i][column[columnIndexForK[0]]]) {
      const bettingstring = `${data[i][column[columnIndexForK[0]]]}#${data[i][column[columnIndexForK[1]]] === '0.00' ? '0' : Number(data[i][column[columnIndexForK[1]]])}#${data[i][column[columnIndexForK[2]]] === '0.00' ? '0' : Number(data[i][column[columnIndexForK[2]]])}${data[i][column[columnIndexForK[3]]] === '0.00' ? '' : `#${Number(data[i][column[columnIndexForK[3]]])}`}\n`
      AfterConvert.push(bettingstring)
      i = (Number(i) + 1).toString()
    }
    i = '3'
    if (data[i] && data[i][column[columnIndexForT[0]]]) {
      AfterConvert.push('3\n')
    }
    while (data[i] && data[i][column[columnIndexForT[0]]]) {
      const bettingstring = `${data[i][column[columnIndexForT[0]]]}#${data[i][column[columnIndexForT[1]]] === '0.00' ? '0' : Number(data[i][column[columnIndexForT[1]]])}#${data[i][column[columnIndexForT[2]]] === '0.00' ? '0' : Number(data[i][column[columnIndexForT[2]]])}${data[i][column[columnIndexForT[3]]] === '0.00' ? '' : `#${Number(data[i][column[columnIndexForT[3]]])}`}\n`
      AfterConvert.push(bettingstring)
      i = (Number(i) + 1).toString()
    }
    i = '3'
    if (data[i] && data[i][column[columnIndexForS[0]]]) {
      AfterConvert.push('4\n')
    }
    while (data[i] && data[i][column[columnIndexForS[0]]]) {
      const bettingstring = `${data[i][column[columnIndexForS[0]]]}#${data[i][column[columnIndexForS[1]]] === '0.00' ? '0' : Number(data[i][column[columnIndexForS[1]]])}#${data[i][column[columnIndexForS[2]]] === '0.00' ? '0' : Number(data[i][column[columnIndexForS[2]]])}${data[i][column[columnIndexForS[3]]] === '0.00' ? '' : `#${Number(data[i][column[columnIndexForS[3]]])}`}\n`
      AfterConvert.push(bettingstring)
      i = (Number(i) + 1).toString()
    }
    this.setState({ AfterConvert })
  }

  async processExcel2() {
    const data = this.state.exceldata;
    const column = data[0] ? Object.keys(data[0]) : [];
    const columnIndexForM = [0, 1, 2]
    const columnIndexForK = [5, 6, 7]
    const columnIndexForT = [10, 11, 12]
    const columnIndexForS = [15, 16, 17]
    let i = '3'
    let AfterConvert = ['D#\n']
    if (data[i] && data[i][column[columnIndexForM[0]]]) {
      AfterConvert.push('1\n')
    }
    while (data[i] && data[i][column[columnIndexForM[0]]]) {
      const bettingstring = `${data[i][column[columnIndexForM[0]]]}#${data[i][column[columnIndexForM[1]]] === '0.00' ? '0' : Number(data[i][column[columnIndexForM[1]]])}${data[i][column[columnIndexForM[2]]] === '0.00' ? '' : `#${Number(data[i][column[columnIndexForM[2]]])}`}\n`
      AfterConvert.push(bettingstring)
      i = (Number(i) + 1).toString()
    }
    i = '3'
    if (data[i] && data[i][column[columnIndexForK[0]]]) {
      AfterConvert.push('2\n')
    }
    while (data[i] && data[i][column[columnIndexForK[0]]]) {
      const bettingstring = `${data[i][column[columnIndexForK[0]]]}#${data[i][column[columnIndexForK[1]]] === '0.00' ? '0' : Number(data[i][column[columnIndexForK[1]]])}${data[i][column[columnIndexForK[2]]] === '0.00' ? '' : `#${Number(data[i][column[columnIndexForK[2]]])}`}\n`
      AfterConvert.push(bettingstring)
      i = (Number(i) + 1).toString()
    }
    i = '3'
    if (data[i] && data[i][column[columnIndexForT[0]]]) {
      AfterConvert.push('3\n')
    }
    while (data[i] && data[i][column[columnIndexForT[0]]]) {
      const bettingstring = `${data[i][column[columnIndexForT[0]]]}#${data[i][column[columnIndexForT[1]]] === '0.00' ? '0' : Number(data[i][column[columnIndexForT[1]]])}${data[i][column[columnIndexForT[2]]] === '0.00' ? '' : `#${Number(data[i][column[columnIndexForT[2]]])}`}\n`
      AfterConvert.push(bettingstring)
      i = (Number(i) + 1).toString()
    }
    i = '3'
    if (data[i] && data[i][column[columnIndexForS[0]]]) {
      AfterConvert.push('4\n')
    }
    while (data[i] && data[i][column[columnIndexForS[0]]]) {
      const bettingstring = `${data[i][column[columnIndexForS[0]]]}#${data[i][column[columnIndexForS[1]]] === '0.00' ? '0' : Number(data[i][column[columnIndexForS[1]]])}${data[i][column[columnIndexForS[2]]] === '0.00' ? '' : `#${Number(data[i][column[columnIndexForS[2]]])}`}\n`
      AfterConvert.push(bettingstring)
      i = (Number(i) + 1).toString()
    }
    this.setState({ AfterConvert })
  }

  async CleanData() {
    this.setState({ FileName: '', FileResultWord: '', AfterConvert: [], DisplayTotalAmount: '' }, () => {
      this.UploadFiletxt()
    })
  }

  onDragOver(evt) {
    evt.preventDefault();
    if (this.state.disabled) return;
  
    this.setState({ hightlight: true });
  }

  onDragLeave() {
    this.setState({ hightlight: false });
  }

  // onDrop(event) {
  //   if (event !== undefined) {
  //     const files = event.dataTransfer.files;
  //     event.preventDefault()
  //     const reader = new FileReader()
  //     reader.onload = async (e) => {
  //       const text = (e.target.result)
  //       this.setState({ FileResultWord: text })
  //     };
  //     if (event.dataTransfer.files) {
  //       reader.readAsText(event.dataTransfer.files[0])
  //       this.setState({ FileName: files[0].name,hightlight: false })
  //     }
  //   }
  // }

  async onDrop(e) {
    e.preventDefault();

    const file = e.dataTransfer.files[0];
    if (!file) return;

    const arrayBuffer = await file.arrayBuffer();

    const workbook = XLSX.read(arrayBuffer, {
      type: "array",
    });

    // First sheet
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];

    // Convert to JSON
    const data = XLSX.utils.sheet_to_json(worksheet, {
      defval: "",
    });

    this.setState({ FileName: file.name, exceldata: data });
  };
  
  openFileDialog() {
    if (this.state.disabled) return
    this.fileInputRef.current.click()
  }

  openNotification(message) {
    this.setState({ notificationMessage: `${language[this.props.currentLanguage][message]}` }, () => {
      this.setState({ showNotification: true });
    });
    clearTimeout(timer)
    timer = setTimeout(() => {
      this.setState({ 
        showNotification: false,
        notificationMessage: '',
        notificationType: 'success',
        disabled: false,
      });
      // this.CleanData()
    }, 5000);
  };

  ChangeReceipt(event) {
    const PressNumber = event.target.value.replace(/[+]/g, '#')
    this.setState({ FileResultWord: PressNumber })
  }

  handleChangeKey(e, Keys, index){
    let getKey1 = this.state.getKey1
    let getKey2 = this.state.getKey2
    if(Keys === 'Key1') {
      getKey1[index] = e.target.value.replace(/[^1-4BSCADE ]/g, "")
    } else {
      getKey2[index] = e.target.value.replace(/[^1-44BSCADE ]/g, "")
    }
    this.setState({ getKey1, getKey2 })
  }

  async exportDading() {
    const AfterConvert = this.state.AfterConvert
    if (AfterConvert === '') {
      this.openNotification('NoDadingData')
      this.setState({ notificationType: 'error' });
    } else {
      var blob = new Blob([AfterConvert.join('')], { type: "text/plain;charset=utf-8" });
      saveAs(blob, `Convert Dading ${Moment(new Date()).format('HH:mm:ss').replace('_', ':')}.txt`);
    }
  }

  ChangeFunctions(event, Mode) {
    this.setState({ [Mode]: event.target.value})
  }

  render() {
    return (
      <div> 
        <SideBar />
        <div style={{ marginLeft: 150, padding: 10, width: `calc(100% - 150)`, flexDirection: 'column', display: 'flex', alignItems: 'flex-start' }}>
          <div className="dcc" style={{ justifyContent: 'center' }}>
            <Alert style={{ zIndex: 99, position: 'fixed', top: 100}}show={this.state.showNotification} variant={this.state.notificationType === 'error' ? 'danger' : 'success'}>
              <Alert.Heading>{this.state.notificationMessage}</Alert.Heading>
            </Alert>
          </div>
          <div style={{ display: 'flex', fontSize: 20, fontWeight: 'bold' }}>
            {language[this.props.currentLanguage].DadingConvert}(PPL)
          </div>
          <div style={{ flexDirection: 'row' }}>
            {this.state.loading ? (
              <div style={{ flexDirection: 'column', width: '100%' }}>
                <div>
                  <img src={Loading3} alt="Logo" className="loadingimages" style={{ marginBottom: 30, marginTop: 50 }} />
                  <div className="loadingMessage">{language[this.props.currentLanguage].LoadingPleaseWaitAMoment}</div>
                </div>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                <div style={{ width: '50%' }}>
                  <div 
                    className={`Dropzone ${this.state.hightlight ? "Highlight" : ""}`}
                    onDragOver={this.onDragOver}
                    onDragLeave={this.onDragLeave}
                    onDrop={this.onDrop}
                    onClick={this.openFileDialog}
                    style={{ cursor: this.state.disabled ? "default" : "pointer", height: 400 }}
                  >
                    <span>Upload Files</span>
                  </div>
                  <input
                    key={this.state.FileName}
                    onChange={(event) => {
                      this.UploadFiletxt(event)
                    }}
                    multiple={false}
                    ref={this.fileInputRef}
                    type='file'
                    hidden
                  />
                  <div style={{ marginBottom: 20, fontWeight: 'bold' }}>{language[this.props.currentLanguage].FileName} : {this.state.FileName || ''}</div>
                  <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                    <button style={{ textAlign: 'center', backgroundColor: '#EE3E13', color: 'white', width: 200, fontWeight: 'bold', marginBottom: 20 }}
                      disabled={this.state.disabled}
                      onClick={() => this.CleanData()}
                      className="btn my-cusomized-button button2">
                      {language[this.props.currentLanguage].ClearAll}
                    </button>
                    <button style={{ textAlign: 'center', backgroundColor: '#0060c7', color: 'white', height: 60, width: 200, fontWeight: 'bold', marginBottom: 20 }}
                      disabled={this.state.disabled}
                      onClick={() => this.processExcel()}
                      className="btn my-cusomized-button button2">
                      处理 Excel BSA
                    </button>
                    <button style={{ textAlign: 'center', backgroundColor: '#37af00', color: 'white', height: 60, width: 200, fontWeight: 'bold', marginBottom: 20 }}
                      disabled={this.state.disabled}
                      onClick={() => this.processExcel2()}
                      className="btn my-cusomized-button button2">
                      处理 Excel AC
                    </button>
                  </div>
                </div>
                <div style={{ fontSize: '28px', fontWeight: 'bold', paddingLeft: 10, paddingRight: 10 }}>⇋</div>
                <div style={{ width: 500 }}>
                  {/* <div style={{ width: '100%', overflowX: 'auto'}}>
                    <Table responsive="sm" bordered hover>
                      <thead style={{ backgroundColor: 'lightgray' }}>
                        <tr>
                          {['all', 'B', 'S', 'CF', 'CA', 'SA'].map((titleitems, idx) => {
                            return(
                              <th key={idx} style={{ width: 'auto' }}>{titleitems}</th>
                            );
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          {['all', 'B', 'S', 'CF', 'CA', 'SA'].map((items, index) => {
                            return(
                              <td key={index} style={{ width: 'auto' }}>{(this.state.DisplayTotalAmount === '') ? '0.00' : Number(this.state.DisplayTotalAmount[items]).toFixed(2)}</td>
                            );
                          })}
                        </tr>
                      </tbody>
                    </Table>
                  </div> */}
                  <div style={{ backgroundColor: 'white', border: `1px solid #d8d8d8`, width: '100%', height: 550, whiteSpace: 'pre-wrap', padding: 10, fontWeight: 'bold', overflowX: 'auto', textAlign: 'left' }}>
                    {this.state.AfterConvert}
                  </div>
                  <div style={{ width: '100%', marginBottom: 50 }}>
                    <div className="dcc button"
                      style={{ backgroundColor: this.state.background, fontSize: 22,
                        borderBottom: '1px solid #cfd9de', verticalAlign: 'middle', fontWeight: 'bold', padding: 13, cursor: 'pointer', borderRadius: 5}} 
                      onMouseEnter={() => {
                        this.setState({ background: '#00AFE2' });
                      }}
                      onMouseLeave={() => {
                        this.setState({ background: '#3C96F4' });
                      }}
                      variant="success" onClick={() => this.exportDading()}>
                      <span>
                        {language[this.props.currentLanguage].DownloadDading}(CSV)
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userID: state.userID,
    username: state.username,
    token: state.token,
    Role: state.Role,
    hide: state.hide,
    currentLanguage: state.currentLanguage,
    UserAuthority: state.UserAuthority,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    setLoginStatus: (Username, UserToken, Role) => {
      dispatch({
        type: 'LOGIN_STATUS',
        payload: {
          username: Username,
          token: UserToken,
          Role: Role,
        },
      });
    },
    setLanguage: (lg) => {
      dispatch({ type: 'SET_LANGUAGE', payload: lg });
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DadingConvertCSV);
